import { render, staticRenderFns } from "./buildup.vue?vue&type=template&id=3c724a3d&"
import script from "./buildup.vue?vue&type=script&lang=js&"
export * from "./buildup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports